module.exports = __webpack_public_path__ + "img/product_fish.c77c859.webp";